jQuery($ => {
    class FrontPageHero {
      constructor(element) {
        this._                 = element;
        this._element          = $(element);
        this._slides           = this._element.find('.o-front-page-hero__media__slide');
        this._testimonials     = this._element.find('.o-front-page-hero__testimonial');
        this._tabsWrapper      = this._element.find('.m-detached-tabs');
        this._tabs             = this._element.find('.m-detached-tabs__tab');
        this._intervalDuration = this._element.find('.o-front-page-hero__media').data('slide-duration');
        this._interval         = null;
        this._isTransitioning  = false;
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        if (this._intervalDuration && this._slides.length > 1) {
          this._interval = setInterval(() => {
            this.goToNextSlide();
          }, this._intervalDuration * 1000);
        }

        this._tabsWrapper.trigger('transition');

        this._tabs.on('click', (e) => {
          const index = $(e.currentTarget).data('tab-index');
          this.goToSlide(index);

          if (this._intervalDuration && this._slides.length > 1) {
            // reset interval
            clearInterval(this._interval);
            this._interval = setInterval(() => {
              this.goToNextSlide();
            }, this._intervalDuration * 1000);
          }
        });

        window.onresize = () => {
          this._tabsWrapper.trigger('transition');
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Go to next slide
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      goToNextSlide = () => {
        let activeSlide = this._slides.filter('.o-front-page-hero__media__slide--active').data('tab-index');
        let nextSlideIndex = activeSlide + 1;
        if (nextSlideIndex >= this._slides.length) {
          nextSlideIndex = 0;
        }
        this.goToSlide(nextSlideIndex);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Go to slide
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      goToSlide = (index) => {
        if (this._isTransitioning) return;

        const activeSlide = this._slides.filter('.o-front-page-hero__media__slide--active');
        if (activeSlide.data('tab-index') === index) return;

        this._isTransitioning = true;
  
        this._tabsWrapper.trigger('transition', [index]);
        this.transitionTestimonials(index);
        this.transitionSlides(index, activeSlide);
      }

      transitionTestimonials = (index) => {
        const activeTestimonial = this._testimonials.filter('.o-front-page-hero__testimonial--active');
        activeTestimonial.removeClass('o-front-page-hero__testimonial--active');
        setTimeout(() => {
          const nextTestimonial = this._testimonials.filter(`[data-tab-index="${index}"]`);
          nextTestimonial.addClass('o-front-page-hero__testimonial--active');
        }, 250);
      }

      transitionSlides = (index, activeSlide) => {
        activeSlide.fadeOut(400, () => {
          activeSlide.removeClass('o-front-page-hero__media__slide--active');

          const nextSlide = this._slides.filter(`[data-tab-index="${index}"]`);          
          nextSlide.fadeIn(400, () => {
            nextSlide.addClass('o-front-page-hero__media__slide--active');
            this._isTransitioning = false;
          });
        });
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.front_page_hero = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].front_page_hero = new FrontPageHero(_[i], opt);
        else
          ret = _[i].front_page_hero[opt].apply(_[i].front_page_hero, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.o-front-page-hero').front_page_hero();
});